import { render, staticRenderFns } from "./HightlightsListWindItem.vue?vue&type=template&id=729e9277&scoped=true&"
import script from "./HightlightsListWindItem.vue?vue&type=script&lang=js&"
export * from "./HightlightsListWindItem.vue?vue&type=script&lang=js&"
import style0 from "./HightlightsListWindItem.vue?vue&type=style&index=0&id=729e9277&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729e9277",
  null
  
)

export default component.exports